import React from 'react';

import { CheckboxGroupProps } from './types';
import { CheckboxGroupContext } from './context';
import { useCheckboxGroupState } from './useCheckboxGroupState';

export const CheckboxGroup = ({ children, ...props }: CheckboxGroupProps) => {
  const context = useCheckboxGroupState(props);

  return (
    <CheckboxGroupContext.Provider value={context}>
      <div role="group" style={{ display: 'contents' }}>
        {children}
      </div>
    </CheckboxGroupContext.Provider>
  );
};
